import type {
    ReportsFilter, ReportFilesResponse, StatusBatchPayload, StatusBatchResponse
} from "../types"
import { instance } from "./api"
import { useAuthStore } from '../stores/t-auth';

async function getReports(filters: ReportsFilter) {
    const auth = useAuthStore();
    let filtros = '?';
    const params = [
        filters.start_date ? `start_date=${filters.start_date}` : '',
        filters.end_date ? `end_date=${filters.end_date}` + '235959' : '',
        filters.type ? `type=${filters.type}` : '',
        filters.mission ? `mission=${filters.mission}` : ''
    ].filter(param => param).join('&');

    filtros += params;

    return await instance.get<ReportFilesResponse>("/reports" + filtros, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function getReportsEvents(reportId: string) {
    const auth = useAuthStore();

    return await instance.get(`/reports/events/${reportId}`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}


async function listReportFiles(filters: ReportsFilter) {
    console.log('listReportFiles - filtros:', filters)
    const auth = useAuthStore();
    let filtros = '?';
    const params = [
        filters.start_date ? `start_date=${filters.start_date}` : '',
        filters.end_date ? `end_date=${filters.end_date}` + '235959' : '',
        filters.type ? `type=${filters.type}` : '',
        filters.mission ? `mission=${filters.mission}` : ''
    ].filter(param => param).join('&');

    filtros += params;
    return await instance.get<ReportFilesResponse>("/reports" + filtros, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
async function listReportsEvents(reportId: string) {
    const auth = useAuthStore();

    return await instance.get(`/reports/events/${reportId}`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
export default {
    getReports,
    getReportsEvents,
    listReportFiles,
    listReportsEvents
};